import { render } from "./GastoForm.vue?vue&type=template&id=6b636079"
import script from "./GastoForm.vue?vue&type=script&lang=js"
export * from "./GastoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__